module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/donna-core/src/app/tax/plugins/tax-settings/tax-settings.plugin.scss
// module id = ./libs/donna-core/src/app/tax/plugins/tax-settings/tax-settings.plugin.scss
// module chunks = main